// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"792":"main","884":"admin"}[chunkId] + "." + {"792":"a0e8b26e1424e2a04f05","884":"91077e49dff5e1324c6e"}[chunkId] + ".css";
};